import './StepperModal.scss';
import '!ng-cache-loader!./templates/SelectCardsTemplate.html';
import '!ng-cache-loader!./templates/LauncherCardsTemplate.html';
class StepperModalController {
    static $inject = ['close', 'steps', 'nextButtonText', 'finishButtonText', 'backButtonText', 'hideProgressBar', 'firstProgressStep', 'trackingId', 'SegmentService'];
    constructor(close, steps, nextButtonText, finishButtonText, backButtonText, hideProgressBar, firstProgressStep, trackingId, SegmentService) {
        this.close = close;
        this.steps = steps;
        this.nextButtonText = nextButtonText;
        this.finishButtonText = finishButtonText;
        this.backButtonText = backButtonText;
        this.hideProgressBar = hideProgressBar;
        this.firstProgressStep = firstProgressStep;
        this.trackingId = trackingId;
        this.SegmentService = SegmentService;
        this.step = 0;
        this.result = {
            finished: false,
            stepsResult: [],
            closed: false,
            closedBy: '',
        };
        this.onCustomValueChange = (event) => {
            const newCustomValue = event.detail.value;
            this.customValue = newCustomValue;
        };
        this._close = this.close;
    }
    get isLastStep() {
        return this.step == this.steps.length - 1;
    }
    get isNextButtonDisabled() {
        if (this.currentTemplate == 'select-cards' &&
            this.numOfSelected < this.minSelections && !this.hasCustomValue) {
            return true;
        }
        return false;
    }
    get templateHtml() {
        if (this.currentTemplate === 'select-cards') {
            return 'SelectCardsTemplate.html';
        }
        if (this.currentTemplate === 'launcher-cards') {
            return 'LauncherCardsTemplate.html';
        }
        return '';
    }
    next() {
        this.pushResult();
        if (!this.isLastStep) {
            this.step++;
        }
        else {
            this.finish();
        }
    }
    finish() {
        this.result.finished = true;
        this.$close('finished');
    }
    pushResult() {
        switch (this.currentTemplate) {
            case 'select-cards':
                this.result.stepsResult.push({
                    selected: this.itemsSelected.map(item => ({
                        key: item.key,
                        text: item.text,
                    })),
                    hasCustomValue: this.hasCustomValue,
                    customValue: this.customValue,
                });
                break;
            default:
                this.result.stepsResult.push({});
        }
    }
    back() {
        this.result.stepsResult.pop();
        if (this.step > 0) {
            this.step--;
        }
    }
    $close(origin) {
        this.result.closed = true;
        this.result.closedBy = origin;
        this._close(this.result);
    }
    get showProgressBar() {
        return !this.hideProgressBar && this.step >= this.firstProgressStep;
    }
    get progress() {
        return (this.steps.length > 1 && this.step >= this.firstProgressStep)
            ? (this.step - this.firstProgressStep) / (this.steps.length - this.firstProgressStep - 1)
            : 0;
    }
    get progressBackgroundColorClass() {
        if (this.progress < 0.5) {
            return 'bp-bg-warning';
        }
        if (this.progress < 1) {
            return 'bp-bg-warning-yellow';
        }
        return 'bp-bg-true';
    }
    get currentStep() {
        if (this.steps.length <= 0) {
            return;
        }
        return this.steps[this.step];
    }
    get currentTemplate() {
        return this.currentStep.template || 'blank';
    }
    get currentSize() {
        return this.currentStep.size || 'sm';
    }
    get currentContent() {
        return this.currentStep.content;
    }
    get showBackButton() {
        return this.step > 0;
    }
    get hideNavigationButtons() {
        return this.currentStep.hideNavigationButtons;
    }
    get secondaryButtonText() {
        return this.backButtonText;
    }
    get primaryButtonText() {
        if (this.isLastStep) {
            return this.finishButtonText;
        }
        else {
            return this.nextButtonText;
        }
    }
    get itemsSelected() {
        return this.currentContent?.items.filter(item => item.selected);
    }
    get numOfSelected() {
        return ((this.itemsSelected?.length || 0) + (this.hasCustomValue ? 1 : 0));
    }
    get maxSelections() {
        return this.currentContent.maxSelections || 1;
    }
    get minSelections() {
        return this.currentContent.minSelections || 1;
    }
    get isMaxSelected() {
        return this.numOfSelected >= this.maxSelections;
    }
    get isMinSelected() {
        return this.numOfSelected >= this.minSelections;
    }
    get customValue() {
        return this.currentContent.customValue || '';
    }
    set customValue(value) {
        this.currentContent.customValue = value;
    }
    get hasCustomValue() {
        return this.customValue !== '';
    }
    toggleSelect(item) {
        if (!item.selected && this.isMaxSelected) {
            return;
        }
        item.selected = !item.selected;
    }
    callCardAction(item) {
        const { action, actionId } = item;
        this.createStepTrack('ai-nlp-stepper-modal-action-card-clicked', { actionId });
        if (action.type === 'function') {
            switch (action.value) {
                case 'next':
                    this.next();
                    break;
                case 'close':
                    this.$close(action.origin);
                    break;
            }
        }
    }
    handleNextButtonClick() {
        if (!this.isLastStep) {
            this.createStepTrack('ai-nlp-stepper-modal-next-button-clicked');
        }
        else {
            this.createStepTrack('ai-nlp-stepper-modal-finish-button-clicked');
        }
        this.next();
    }
    handleBackButtonClick() {
        this.createStepTrack('ai-nlp-stepper-modal-back-button-clicked');
        this.back();
    }
    handleCloseIconClick() {
        this.createStepTrack('ai-nlp-stepper-modal-close-icon-clicked');
        this.$close('close-icon');
    }
    createStepTrack(trackEvent, payload) {
        const currentStep = `${this.step + 1}`;
        this.SegmentService.createApplicationTrack({ trackEvent: trackEvent, payload: { currentStep, trackId: this.trackingId, ...payload } });
    }
}
StepperModalController.$inject = ['close', 'steps', 'nextButtonText', 'finishButtonText', 'backButtonText', 'hideProgressBar', 'firstProgressStep', 'trackingId', 'SegmentService'];
export default StepperModalController;
